/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FaqDto } from '../../models/faq-dto';
import { FaqShowResponse } from '../../models/faq-show-response';

export interface PostFaqCreate$Params {
      body: FaqDto
}

export function postFaqCreate(http: HttpClient, rootUrl: string, params: PostFaqCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqShowResponse>> {
  const rb = new RequestBuilder(rootUrl, postFaqCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FaqShowResponse>;
    })
  );
}

postFaqCreate.PATH = '/v1/faq';
